import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import { Col, Row } from 'react-flexbox-grid'
import styles from './_activeGoalDetails.css'
import ItemRow from 'components/layout/ItemRow'
import PerformanceMetric from './PerformanceMetric'
import Button from 'components/util/Button'

export default function ActiveGoalDetails ({ performanceMetrics, startTime, deleteGoal }) {
  const metricNodes = performanceMetrics.map((metric, i) =>
    <PerformanceMetric
      key={i}
      goalType={metric.data_type_field}
      value={metric.value} />
  )

  const duration = moment(new Date(startTime)).toNow(true)

  return (
    <div className={styles.activeGoalDetailContainer}>
      <ItemRow nodes={metricNodes} cols={2} />
      <Row>
        <Col xs={6} className={styles.totalsContainer}>
          <FormattedMessage
            id='goaldetail.totaltime'
            defaultMessage='Total Time' />
          <span className={styles.goalDuration}>
            {duration}
          </span>
        </Col>
        <Col xs={6} className={styles.stopGoalContainer}>
          <Button
            className={styles.stopGoal}
            onClick={deleteGoal}
            el='button'
            type='danger'
            size='small'>
            <FormattedMessage
              id='goaldetail.remove'
              defaultMessage='Stop Goal' />
          </Button>
        </Col>
      </Row>
    </div>
  )
}

ActiveGoalDetails.propTypes = {
  performanceMetrics: PropTypes.array,
  startTime: PropTypes.string,
  deleteGoal: PropTypes.func,
}
